import { store } from "./../../redux/";
import { call, put } from "redux-saga/effects";
import { url } from "./../../services/Url";
import CONSTANTS from "../../util/constants";
import APICallingService from "../../services/APICallingService";

const createLocationAPI = (value) => {
  let payload = {
    name: value.name,
    zip: value.zip,
    state: value.state,
    phone: value.phone,
    contactFirstName: value.firstName,
    contactLastName: value.lastName,
    streetAddress: value.streetAddress,
    city: value.city,
    divisions: value.divisions,
  };

  return APICallingService.sendRequestForPostWithAuth(
    url.addLocation,
    payload,
    false,
    (res) => {},
    true
  );
};

function* createLocation(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(createLocationAPI, action.payload.value);

    if (response && response?.callBackStatus.toLowerCase() == "success") {
      alert("Location Added Successfully");

      yield put({
        type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.GET_LOCATION_API_CALL,
      });
      yield put({
        type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.ADD_LOCATION_API_SUCCESS,
        payload: { value: response?.callBackStatus },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("No Location Data available");
        yield put({
          type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
            .ADD_LOCATION_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.ADD_LOCATION_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const editLocationAPI = (value) => {
  let urlEdit = url.editLocation + value.id.toString();

  let payload = {
    name: value.name,
    zip: value.zip,
    state: value.state,
    phone: value.phone,
    contactFirstName: value.firstName,
    contactLastName: value.lastName,
    streetAddress: value.streetAddress,
    city: value.city,
    divisions: value.divisions,
    isActive: value?.is_active === false ? false : true,
    is_active: value?.is_active === false ? false : true,
  };
  console.log("payloadpayload123", payload);

  return APICallingService.sendRequestForPut(
    payload,
    urlEdit,
    (res) => {},
    true
  );
};

function* editLocation(action) {
  console.log("editLocation123", action);
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(editLocationAPI, action.payload.value);

    if (
      response &&
      response != null &&
      response.callBackStatus.toLowerCase() == "success"
    ) {
      alert("Location Updated Successfully");
      yield put({
        type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.GET_LOCATION_API_CALL,
      });
      yield put({
        type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.EDIT_LOCATION_API_SUCCESS,
        payload: { value: response?.callBackStatus },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Failed to update location");
        yield put({
          type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
            .EDIT_LOCATION_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.EDIT_LOCATION_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const getLocationAPI = (value) => {
  if (value)
    return APICallingService.sendRequestForGet(
      url.locationsForMove + "/" + value,
      (res) => {},
      true
    );
  else
    return APICallingService.sendRequestForGet(
      url.getLocation,
      (res) => {},
      true
    );
};

function* getLocation(action) {
  try {
    let s = store.getState();
    let getByDivision = false;
    if (action.payload?.value?.bydivision) getByDivision = true;
    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(getLocationAPI, getByDivision);
    if (response && response != null) {
      yield put({
        type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.GET_LOCATION_API_SUCCESS,
        payload: { value: response.data },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Failed to get location data");
        yield put({
          type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
            .GET_LOCATION_API_SUCCESS,
          payload: { value: "Failed" },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.GET_LOCATION_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const getLocationByIdAPI = () => {
  return APICallingService.sendRequestForGet(
    url.getLocationByID,
    (res) => {},
    true
  );
};

function* getLocationById(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(getLocationByIdAPI);
    if (response && response != null) {
      yield put({
        type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
          .GET_LOCATIONBYID_API_SUCCESS,
        payload: { value: response.data },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Failed to get Locations data ");
        yield put({
          type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
            .GET_LOCATIONBYID_API_SUCCESS,
          payload: { value: "Failed" },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
        .GET_LOCATIONBYID_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

export { editLocation, createLocation, getLocation, getLocationById };
